import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  CheckCircleIcon, 
  ExclamationTriangleIcon, 
  XCircleIcon,
  InformationCircleIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const MessageDisplay = ({ message, onClose }) => {
  if (!message) return null;

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon className="h-6 w-6 text-green-500" />;
      case 'error':
        return <XCircleIcon className="h-6 w-6 text-red-500" />;
      case 'warning':
        return <ExclamationTriangleIcon className="h-6 w-6 text-yellow-500" />;
      case 'info':
      default:
        return <InformationCircleIcon className="h-6 w-6 text-blue-500" />;
    }
  };

  const getBgColor = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-50 border-green-200';
      case 'error':
        return 'bg-red-50 border-red-200';
      case 'warning':
        return 'bg-yellow-50 border-yellow-200';
      case 'info':
      default:
        return 'bg-blue-50 border-blue-200';
    }
  };

  const getTextColor = (type) => {
    switch (type) {
      case 'success':
        return 'text-green-800';
      case 'error':
        return 'text-red-800';
      case 'warning':
        return 'text-yellow-800';
      case 'info':
      default:
        return 'text-blue-800';
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -50, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -50, scale: 0.95 }}
        className="fixed top-4 left-4 right-4 z-[9998] max-w-md mx-auto sm:left-1/2 sm:right-auto sm:transform sm:-translate-x-1/2"
      >
        <div className={`rounded-xl border-2 p-4 shadow-lg backdrop-blur-sm w-full ${getBgColor(message.type)}`}>
          <div className="flex items-start">
            <div className="flex-shrink-0">
              {getIcon(message.type)}
            </div>
            <div className="ml-3 flex-1">
              {message.title && (
                <h3 className={`text-sm font-bold ${getTextColor(message.type)} mb-1`}>
                  {message.title}
                </h3>
              )}
              <div className={`text-sm ${getTextColor(message.type)}`}>
                {typeof message.content === 'string' ? (
                  <p>{message.content}</p>
                ) : (
                  message.content
                )}
              </div>
              {message.details && (
                <div className="mt-2 text-xs text-gray-600">
                  {typeof message.details === 'string' ? (
                    <p>{message.details}</p>
                  ) : (
                    message.details
                  )}
                </div>
              )}
            </div>
            <div className="ml-4 flex-shrink-0">
              <button
                onClick={onClose}
                className={`rounded-md p-1 hover:bg-white/50 transition-colors ${getTextColor(message.type)}`}
              >
                <XMarkIcon className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default MessageDisplay;
